import axios from "axios";
import authHeader from "./auth-header";

const API_URL = "https://hexeverestfunctions.azurewebsites.net/api/";
// const API_URL = "http://localhost:7071/api/";

class UserService {
  changeDepartment(departmentChangeData) {
    return axios.post(
      API_URL + "ChangeEmployeesDepartment",
      departmentChangeData,
      {
        headers: authHeader(),
      },
    );
  }

  getUserContent() {
    return axios.get(API_URL + "GetAllMyReports", { headers: authHeader() });
  }

  getUserCompany() {
    return axios.get(API_URL + "GetMyCompany", { headers: authHeader() });
  }

  getDepartments() {
    return axios.get(API_URL + "GetAllDepartmentsOfMyCompany", {
      headers: authHeader(),
    });
  }

  getDepartmentsExceptStadionLogistika() {
    return axios.get(
      API_URL + "GetAllDepartmentsOfMyCompanyExepctStadionLogistika",
      {
        headers: authHeader(),
      },
    );
  }

  getDepartmentsJustStadionLogistika() {
    return axios.get(
      API_URL + "GetAllDepartmentsOfMyCompanyJustStadionLogistika",
      {
        headers: authHeader(),
      },
    );
  }

  getEmployees() {
    return axios.get(API_URL + "GetEmployeesWithCardsAndVehicles", {
      headers: authHeader(),
    });
  }

  getCheckpointNames() {
    return axios.get(API_URL + "GetCheckpointNames", {
      headers: authHeader(),
    });
  }

  getCheckpointsOfInsideGates() {
    return axios.get(API_URL + "GetCheckpointsOfInsideGates", {
      headers: authHeader(),
    });
  }

  getVehicles() {
    return axios.get(API_URL + "GetAllVehicles", { headers: authHeader() });
  }

  getMyCompany() {
    return axios.get(API_URL + "GetMyCompany", { headers: authHeader() });
  }

  getMe() {
    return axios.get(API_URL + "GetMe", { headers: authHeader() });
  }

  getFreeVehicles() {
    return axios.get(API_URL + "GetAllFreeVehicles", { headers: authHeader() });
  }

  getRoutes() {
    return axios.get(API_URL + "GetAllRoutes", {
      headers: authHeader(),
    });
  }

  postDepartment(department) {
    return axios.post(API_URL + "CreateDepartment", department, {
      headers: authHeader(),
    });
  }

  putDepartment(department) {
    return axios.put(API_URL + "EditDepartment", department, {
      headers: authHeader(),
    });
  }

  deleteDepartment(department) {
    return axios.delete(API_URL + "DeleteDepartment", {
      headers: authHeader(),
      data: { department },
    });
  }

  postEmployee(emplyee) {
    return axios.post(API_URL + "CreateEmployee", emplyee, {
      headers: authHeader(),
    });
  }

  putEmployee(employee) {
    return axios.put(API_URL + "EditEmployee", employee, {
      headers: authHeader(),
    });
  }

  deleteEmployee(employee) {
    return axios.delete(API_URL + "DeleteEmployee", {
      headers: authHeader(),
      data: employee,
    });
  }

  postCard(card) {
    return axios.post(API_URL + "CreateCard", card, { headers: authHeader() });
  }

  putCard(card) {
    return axios.put(API_URL + "EditCard", card, { headers: authHeader() });
  }

  deleteCard(card) {
    return axios.delete(API_URL + "DeleteCard", {
      headers: authHeader(),
      data: card,
    });
  }

  postVehicle(vehicle) {
    return axios.post(API_URL + "CreateVehicle", vehicle, {
      headers: authHeader(),
    });
  }

  putVehicle(vehicle) {
    return axios.put(API_URL + "EditVehicle", vehicle, {
      headers: authHeader(),
    });
  }

  deleteVehicle(vehicle) {
    return axios.delete(API_URL + "DeleteVehicle", {
      headers: authHeader(),
      data: vehicle,
    });
  }

  postRoute(route) {
    return axios.post(API_URL + "CreateRoute", route, {
      headers: authHeader(),
    });
  }

  putRoute(route) {
    return axios.put(API_URL + "EditRoute", route, {
      headers: authHeader(),
    });
  }

  deleteRoute(route) {
    return axios.delete(API_URL + "DeleteRoute", {
      headers: authHeader(),
      data: route,
    });
  }

  GetSaturdayShifts() {
    return axios.get(API_URL + "GetSaturdayShifts", {
      headers: authHeader(),
    });
  }

  getShifts() {
    return axios.get(API_URL + "GetAllShifts", {
      headers: authHeader(),
    });
  }

  postSaturdayShift(saturdayShift) {
    return axios.post(API_URL + "CreateSaturdayShift", saturdayShift, {
      headers: authHeader(),
    });
  }

  postShift(shift) {
    return axios.post(API_URL + "CreateShift", shift, {
      headers: authHeader(),
    });
  }

  putShift(shift) {
    return axios.put(API_URL + "EditShift", shift, {
      headers: authHeader(),
    });
  }

  deleteShift(shift) {
    return axios.delete(API_URL + "DeleteShift", {
      headers: authHeader(),
      data: shift,
    });
  }

  postAbsence(absence) {
    console.log("jaja");
    console.log(absence);
    return axios.post(API_URL + "CreateAbsence", absence, {
      headers: authHeader(),
    });
  }

  putAbsence(absence) {
    return axios.put(API_URL + "EditAbsence", absence, {
      headers: authHeader(),
    });
  }

  deleteAbsence(absence) {
    return axios.delete(API_URL + "DeleteAbsence", {
      headers: authHeader(),
      data: absence,
    });
  }

  getUsers() {
    return axios.get(API_URL + "GetUsers", { headers: authHeader() });
  }

  postUser(usr) {
    return axios.post(API_URL + "CreateUser", usr, {
      headers: authHeader(),
    });
  }

  putUser(usr) {
    console.log("user.sevide.js");
    console.log(usr);
    return axios.put(API_URL + "EditUser", usr, {
      headers: authHeader(),
    });
  }

  getStoreNameByCoordinations(lat, long) {
    console.log(lat);
    console.log(long);
    return axios.get(
      API_URL + "GetGpsLocationNameByCoordinates?lat=" + lat + "&lng=" + long,
      { headers: authHeader() },
    );
  }

  // UserDepartment methods
  getUserDepartments() {
    return axios.get(API_URL + "GetUserDepartments", { headers: authHeader() });
  }

  getUserDepartmentsByUserId(userId) {
    return axios.get(API_URL + "GetUserDepartmentsByUserId/" + userId, {
      headers: authHeader(),
    });
  }

  createUserDepartment(userDepartment) {
    return axios.post(API_URL + "CreateUserDepartment", userDepartment, {
      headers: authHeader(),
    });
  }

  editUserDepartment(userDepartment) {
    return axios.put(API_URL + "EditUserDepartment", userDepartment, {
      headers: authHeader(),
    });
  }

  deleteUserDepartment(userDepartmentId) {
    return axios.delete(API_URL + "DeleteUserDepartment/" + userDepartmentId, {
      headers: authHeader(),
    });
  }

  getEmployeesForSubdepartmentSelection(departmentId) {
    return axios.get(
      API_URL + "GetEmployeesForSubdepartmentSelection/" + departmentId,
      { headers: authHeader() },
    );
  }

  // UserReport methods
  getUserReports() {
    return axios.get(API_URL + "GetUserReports", { headers: authHeader() });
  }

  getUserReportsByUserId(userId) {
    return axios.get(API_URL + "GetUserReportsByUserId/" + userId, {
      headers: authHeader(),
    });
  }

  createUserReport(userReport) {
    return axios.post(API_URL + "CreateUserReport", userReport, {
      headers: authHeader(),
    });
  }

  createUserReportsBulk(userReports) {
    return axios.post(API_URL + "CreateUserReportsBulk", userReports, {
      headers: authHeader(),
    });
  }

  editUserReport(userReport) {
    return axios.put(API_URL + "EditUserReport", userReport, {
      headers: authHeader(),
    });
  }

  deleteUserReport(userReportId) {
    return axios.delete(API_URL + "DeleteUserReport/" + userReportId, {
      headers: authHeader(),
    });
  }

  deleteUserReportsByUserId(userId) {
    return axios.delete(API_URL + "DeleteUserReportsByUserId/" + userId, {
      headers: authHeader(),
    });
  }

  getAvailableReports() {
    return axios.get(API_URL + "GetAvailableReports", {
      headers: authHeader(),
    });
  }

  // Download user credentials PDF
  downloadUserCredentialsPdf(userId) {
    return axios.get(API_URL + "GenerateUserCredentialsPdf/" + userId, {
      headers: authHeader(),
      responseType: "blob",
    });
  }
}

export default new UserService();
